const cpdCategoriesFormModel = {
  formId: 'CpdCategoriesForm',
  formField: {
    AccreditedCeActivity: {
      name: 'AccreditedCeActivity',
      label: 'Accredited CE activity',
      informationText: 'External to the workplace - local, national, and international.'
    },
    ProfessionalDevelopmentPlan: {
      name: 'ProfessionalDevelopmentPlan',
      label: 'Professional development plan',
      informationText: 'A tool to capture your annual planned CPD activities. Refer to professional development plan link on the portal home page.'
    },
    PracticeReview: {
      name: 'PracticeReview',
      label: 'Practice review',
      informationText: 'Audit, quality improvement, and/or practice evaluation.'
    },
    WorkbasedLearning: {
      name: 'WorkbasedLearning',
      label: 'Workbased learning',
      informationText: 'Reflective learning from clinical and non-clinical work.'
    },
    Total: {
      name: 'Total',
      label: 'Total',
      informationText: 'Total.'
    },
    OnTarget: {
      name: 'OnTarget',
      label: 'On target',
      informationText: 'Indicates achievement of Medical council CPD target requirements.'
    },
  }
};

export default cpdCategoriesFormModel;